import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import { Button, ButtonGroup } from "@mui/material";
import classNames from "classnames";
import { useEffect, useState } from "react";
const StyledButtonGroup = styled(ButtonGroup)(({ style }) => ({
    display: "inline-flex",
    padding: "4px",
    backgroundColor: palette.bg010,
    border: `1px solid ${palette.grey020}`,
    ...style,
}));
const StyledButton = styled(Button)(({ style }) => ({
    "&.MuiButton-root": {
        padding: "2px 16px",
        borderRadius: "4px",
        height: "24px",
        ...style,
    },
    "&.MuiButton-containedPrimary": {
        backgroundColor: palette.white,
        boxShadow: `0px 2px 8px 0px ${palette.black}1A`,
        ...typography["Content.Subtitle03"],
        color: palette.grey090,
    },
    "&.MuiButton-outlinedPrimary": {
        border: "none",
        backgroundColor: "transparent",
        ...typography["Content.Body03"],
        color: palette.grey030,
    },
}));
export function GrSegment(props) {
    var _a;
    const [selectedIndex, setSelectedIndex] = useState((_a = props.selectedIndex) !== null && _a !== void 0 ? _a : 0);
    useEffect(() => {
        var _a;
        setSelectedIndex((_a = props.selectedIndex) !== null && _a !== void 0 ? _a : 0);
    }, [props.selectedIndex]);
    function handleClick(e, index) {
        var _a, _b, _c;
        setSelectedIndex(index);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, index);
        (_c = (_b = props.items[index]).onClick) === null || _c === void 0 ? void 0 : _c.call(_b, e, index);
    }
    return (_jsx(StyledButtonGroup, { className: classNames("GrSegment", props.className), size: "small", "aria-label": "small button group", fullWidth: props.fullWidth, style: props.style, children: props.items.map((item, index) => (_jsx(StyledButton, { onClick: e => handleClick(e, index), variant: selectedIndex === index ? "contained" : "outlined", disableFocusRipple: true, disableRipple: true, disableTouchRipple: true, disabled: props.disabled || item.disabled, style: item.style, children: item.label }, index))) }));
}
//# sourceMappingURL=GrSegment.js.map